import Role from "./Role.js";

/**
 * `companyRole` describes roles of a company over other users.
 *
 * @abstract
 * @param {string[]} spec.companyIds - Identifiers of companies the role is bound to
 */
export default class CompanyRole extends Role {
	constructor({ companyIds } = {}) {
		super(...arguments);
		this._companyIds = companyIds;
	}

	//
	// canDelete
	//

	canBeDeletedByCountryUser() {
		return true;
	}

	canBeDeletedByDirector(role) {
		return this._isForSameAgency(role);
	}

	canBeDeletedByConsultant(role) {
		return (
			this._companyIds &&
			role.canAdministrateAllCompanyIds(this._companyIds)
		);
	}

	// eslint-disable-next-line sonarjs/no-identical-functions -- we should fix that
	canBeDeletedByCompanyAdmin(role) {
		return (
			this._companyIds &&
			role.canAdministrateAllCompanyIds(this._companyIds)
		);
	}

	//
	// canAttachOrDetachCompanyId
	//

	canCompanyIdBeAttachedOrDetachedByCountryUser() {
		return true;
	}

	canCompanyIdBeAttachedOrDetachedByDirector(role) {
		return this._isForSameAgency(role);
	}

	canCompanyIdBeAttachedOrDetachedByConsultant(role, companyId) {
		return role.canAdministrateCompanyId(companyId);
	}

	canCompanyIdBeAttachedOrDetachedByCompanyAdmin(role, companyId) {
		return role.canAdministrateCompanyId(companyId);
	}

	//
	// canEditUserInfo
	//

	canUserInfoBeEditedByCountryUser() {
		return true;
	}

	canUserInfoBeEditedByDirector(role) {
		return this._isForSameAgency(role);
	}

	canUserInfoBeEditedByConsultant(role) {
		return (
			this._companyIds &&
			role.canAdministrateAnyCompanyId(this._companyIds)
		);
	}

	canViewAccountingDocuments(company) {
		return (
			!company.isLightCompany() &&
			this._companyIds.includes(company.getLegacyId())
		);
	}

	canAdministrateCompanyId(companyId) {
		return this._companyIds.includes(companyId);
	}

	canAdministrateAllCompanyIds(otherCompanyIds) {
		return otherCompanyIds.every(this.canAdministrateCompanyId.bind(this));
	}

	canAdministrateAnyCompanyId(otherCompanyIds) {
		return otherCompanyIds.some(this.canAdministrateCompanyId.bind(this));
	}
}
